<div class="p-4 w-[960px]">
    <div class="flex justify-between items-center">
        <h1 class="text-xl md:text-2xl font-bold text-light-textColor dark:text-dark-textColor mb-2">{{ 'workflow.workflow-create.title' | translate }}</h1>
        <span tabindex="1" role="button" class="icon-close-large"
              [attr.aria-label]="'workflow.workflow-create.close-create-workflow' | translate"
              (click)="onDialogClose()"></span>
    </div>
    <app-sap-search-progress />

    @if (!selectedWorkflowConfigId()) {
        <p class="text-light-textColor dark:text-dark-textColor mb-8 md:text-md lg:text-lg text-sm">{{ 'workflow.workflow-create.subtitle' | translate }}</p>

        <div class="flex max-h-[75vh] mt-8 relative">
            <div class="w-80 p-6 sticky min-h-[30vh] overflow-auto">
                <sag-ui-stepper
                    [steps]="steps()"
                    [active]="activeStep()"
                    [activeSubStep]="activeSection()"
                    [disabledSteps]="disabledSteps()"
                    (selectedChange)="setStep($event)"
                    (selectedSubStepChange)="setSection($event)"
                    orientation="vertical"
                >
                </sag-ui-stepper>
            </div>
            <div class="flex-1 ml-8 overflow-auto">

                <app-workflow-config-details [workflowConfigFormGroup]="workflowConfigFormGroup"
                                             [workflowTypes]="workflowTypes()" />
            </div>

        </div>
    } @else {
        <p class="text-light-textColor dark:text-dark-textColor mb-8 md:text-md lg:text-lg text-sm">{{
                'workflow.workflow-create.subtitle-with-type-and-name' | translate: {
                    workflowType: selectedWorkflowConfig().type | translate,
                    workflowName: selectedWorkflowConfig().name | translate
                }
            }}</p>
        <app-workflow [useRouting]="false" bgColor="bg-light-bgColorSecondary dark:bg-dark-bgColorSecondary"></app-workflow>
    }
</div>
